export default "__VITE_ASSET__CSZCqKQb__"